/*! @azure/msal-browser v5.6.3 2026-04-01 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "5.6.3";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
